export default __webpack_public_path__ + "static/media/bars-solid.c026ee61.svg";